export default __webpack_public_path__ + "static/media/logo_offroad.83bcc17e.png";